
import { AggregatedSymbol } from '../../types';

// List of common valid stock symbols to use as fallback
export const COMMON_VALID_SYMBOLS = [
  'AAPL', 'MSFT', 'GOOGL', 'GOOG', 'AMZN', 'META', 'NFLX', 'TSLA', 'NVDA', 'AMD',
  'INTC', 'IBM', 'JPM', 'BAC', 'C', 'WFC', 'GS', 'V', 'MA', 'PYPL', 'DIS', 'CMCSA',
  'VZ', 'T', 'PFE', 'JNJ', 'MRK', 'CVX', 'XOM', 'KO', 'PEP', 'WMT', 'TGT', 'COST',
  'HD', 'LOW', 'SBUX', 'MCD', 'SPGI', 'SPY', 'QQQ', 'DIA', 'IWM', 'VTI', 'CSCO', 'ORCL'
];

import { generateMockPrice, getMockPriceConfig, validateMockDataUsage } from '@/config/mock-data-config';

// Generate "realistic" mock market data using centralized configuration
export const generateMockMarketData = (symbolUpperCase: string) => {
  // Validate that we're using mock data and warn if in production
  validateMockDataUsage(`generateMockMarketData for ${symbolUpperCase}`);
  
  const config = getMockPriceConfig(symbolUpperCase);
  const mockPrice = generateMockPrice(symbolUpperCase);
  
  return {
    lastPrice: mockPrice,
    zscore: (Math.random() * 4) - 2, // -2 to +2 standard deviations
    volatility: config.dailyVolatility,
    correlations: {}
  };
};

// Generate mock correlation between two symbols
export const generateMockCorrelation = () => {
  return (Math.random() * 1.6) - 0.8; // Between -0.8 and 0.8
};

// Check if we're in dev mode
export const isDevEnvironment = () => {
  return import.meta.env.DEV || !import.meta.env.VITE_ALPHA_VANTAGE_API_KEY;
};

// Normalize symbol format
export const normalizeSymbol = (symbol: string) => {
  return symbol.trim().toUpperCase();
};

// Extract symbols from an array of AggregatedSymbol objects
export const extractSymbolNames = (symbols: AggregatedSymbol[]): string[] => {
  return symbols.map(s => normalizeSymbol(s.symbol));
};
